import React from "react";
import { Link } from "react-router-dom";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import '../components/css/CourseStyle.css';
import Footer from '../components/Footer';
// import course1 from '../components/courses/csir-net1.png';
// import course2 from '../components/courses/csir-net2.png';
// import course3 from '../components/courses/csir-net3.png';
import tag from '../components/images/onlineTag.webp';
import banners from '../components/courses/iitjamcour.png';

function IITGate (){
    return (
        <>
            <Headertop /> 
            <Navbar />
            
            <section className="bg-red text-white">
                <img src={banners} className="courseBanner" alt="" />
            </section>

            <section className="py-3">
                <div className="container">
                    <nav aria-label="breadcrumbs">
                        <ol className="breadcrumbs">
                            <li className="breadcrumbs-item itemslist"><Link to="/"><i className="bi bi-house"></i></Link></li>
                            <li className="breadcrumbs-item active" aria-current="page">CSIR NET</li>
                        </ol>
                    </nav>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="mb-5">
                        <h2 className="fw-bold">IIT JAM Exam</h2>
                        <p className="text-muted">IIT JAM Online Coaching is available at Vigyan Vriksh for Chemistry. Start your journey with live classes, study notes, practice tests & doubt sessions. Join paid or free courses to prepare easily for IIT JAM 2026 exam.</p>

                    </div>

                    <div className="row g-4">
                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-blue">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-display fs-3"></i></div>
                                    <h5 className="fw-bold">Blogs</h5>
                                    <p className="text-muted mb-0">Read Our Latest Blogs</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-pink">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-journal-text fs-3"></i></div>
                                    <h5 className="fw-bold">Online Courses</h5>
                                    <p className="text-muted mb-0">Access Our Latest Courses</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-green">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-clipboard-check fs-3"></i></div>
                                    <h5 className="fw-bold">Test Series</h5>
                                    <p className="text-muted mb-0">Practice with Our Mock Test</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-lightblue">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-book fs-3"></i></div>
                                    <h5 className="fw-bold">Books</h5>
                                    <p className="text-muted mb-0">Find Preparation Books</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container my-5">    
                <h3 class="fw-bold mb-4">IIT JAM Courses</h3>
                <div class="row g-4">
                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/4_1762247933922.png&w=3840&q=75" class="img-fluid" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/super-100-iit-jam-2028" class="text-dark" target="_blank">SUPER 100 Live IIT JAM 2028</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>2 </b>Year <b class="bi bi-bookmark-check"></b> <b>3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹20,547.62</span>
                                    {/* <span class="price-old">₹5,999</span> */}
                                    <div class="discount mt-2 p-3">Live Interactive Classes<br/>Topic-wise, real-time sessions with India’s top faculty<br/>Ask doubts instantly — get cla</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/super-100-iit-jam-2028" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/2_1762247974753.png&w=3840&q=75" class="img-fluid" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/iit-jam-2028-basic-2-advance" class="text-dark" target="_blank">Basic to Advance IIT JAM 2028</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>2 </b>Year <b class="bi bi-bookmark-check"></b> <b>3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹18,492.76</span>
                                    {/* <span class="price-old">₹5,999</span> */}
                                    <div class="discount mt-2 p-3">Recorded Classes<br/>Topic-wise, real-time sessions with India’s top faculty<br/>Ask doubts instantly — get clarity on the spot!</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/iit-jam-2028-basic-2-advance" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/6_1762248188472.png&w=3840&q=75" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/iit-jam-2028-rec" class="text-dark" target="_blank">Recorded IIT JAM 2028</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>2 </b>year <b class="bi bi-bookmark-check"></b> <b>3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹15,410.46</span>
                                    {/* <span class="price-old">₹5,999</span> */}
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/iit-jam-2028-rec" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/8_1762248235860.png&w=3840&q=75" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/p-jam-2028" class="text-dark" target="_blank">Physical Chemistry CSIR Dec 2026</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>2 </b>Year <b class="bi bi-bookmark-check"></b> <b> 3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">Physical Chemistry CSIR June 26 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹7,191</span>
                                    <div class="discount mt-2 p-3">Physical Chemistry</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/p-jam-2028" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/10_1762248293028.png&w=3840&q=75" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/o-jam-2028" class="text-dark" target="_blank">Organic Chemistry CSIR June 2026</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>2</b> year <b class="bi bi-bookmark-check"></b> <b>3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">Organic Chemistry CSIR June 2026 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹7,191</span>
                                    <div class="discount mt-2 p-3">Organic Chemistry</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/o-jam-2028" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://diy-assets.classplus.co/_next/image?url=https://cdn-diy-public.classplus.co/prod/11_1762156310924.png&w=3840&q=75" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/i-jam-2028" class="text-dark" target="_blank">Inorganic Chemistry IIT JAM 2028</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li>
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>2</b> year <b class="bi bi-bookmark-check"></b> <b>3</b> Learning Material</li>
                                </ul>
                                <div class="batch-strip my-2">Inorganic Chemistry CSIR June 2026 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹7,191</span>
                                    <div class="discount mt-2 p-3">Inorganic Chemistry</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/i-jam-2028" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-4">
                    <Link to="#" class="btn btn-light border rounded-pill px-4 py-2 text-primary fw-semibold">View All Batches <i class="bi bi-arrow-right"></i></Link>
                </div>
            </section>

            <section className="container coursebox py-3">
                <div class="row g-4">
                    <h3>IIT JAM Exam 2026</h3>
                    <p>The IIT JAM Exam is a very competitive test for students who wish to take admission in M.Sc. and other postgraduate science courses at top IITs and institutes in India. To do well in this exam, it is important for students to understand their subjects clearly and keep track of the latest exam pattern and syllabus. The exam focuses on basic concepts and problem-solving skills, so having a good study plan is important. With proper study materials, regular practice, and clear concepts, students can improve their preparation for the IIT JAM 2026 exam.</p>

                    <h3>IIT JAM Online Classes</h3>
                    <p>Vigyan Vriksh Online Coaching for IIT JAM 2026 is designed to help you prepare thoroughly for the exam. Our courses are created by teachers who have helped many students prepare for IIT JAM exams.</p>
                    <p>PW IIT JAM Online Coaching includes live and recorded classes, study materials, and past years' question papers. The platform is easy to use, so you can easily find and access all the resources you need. You'll also receive updates about important dates, exam patterns, and changes in the IIT JAM syllabus.</p>
                    <p>In addition, interactive doubt-clearing sessions with teachers help you understand the material better and get ready for the exam.</p>

                    <h3>IIT JAM Online Courses</h3>
                    <p>Vigyan Vriksh’s IIT JAM online courses offer a flexible and complete way to prepare for the IIT JAM 2025 exam. These courses are designed to help you build the knowledge and skills needed for both IIT JAM and CUET PG exams. The courses include video lessons, detailed study materials, plenty of practice questions, and mock tests. Our courses are organized to provide a clear and effective way of preparing. Here are the subject-specific courses available.</p>

                    <h3>IIT JAM Chemistry Online Course</h3>
                    <p>For the IIT JAM Chemistry Exam 2025, PW provides qualified faculty for IIT JAM Chemistry Online Coaching. Our courses, including Saakaar 2.0 2026, Saakaar 2026, Saakaar Pro 2026, and Saakaar 2025, provide live classes, PDF notes, practice questions, and tests to help you prepare in a complete way.</p>

                    <h3>IIT JAM Online Course Details</h3>
                    <p>Vigyan Vriksh offers a variety of IIT JAM 2026 online courses for different subjects to help students prepare well for the exam. These courses cover full syllabus with video lectures, notes, and practice tests. You can check the list of PW’s IIT JAM online courses below and join the one that suits your subject.</p>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th colSpan={2}>IIT JAM Online Courses Details</th>
                            </tr>
                            <tr>
                                <td>Exam Name</td>
                                <td>Course Links</td>
                            </tr>
                            <tr>
                                <td>Basic to Advance Batch</td>
                                <td>Saakaar Pro 2026 Chemistry</td>
                            </tr>
                            <tr>
                                <td>Recorded Batch</td>
                                <td>Saakaar Pro 2026 Mathematics</td>
                            </tr>
                            <tr>
                                <td>Organic Chemistry</td>
                                <td>Saakar Pro 2026 Physics</td>
                            </tr>
                            <tr>
                                <td>Physical Chemistry</td>
                                <td>Saakar Pro 2026 Biotechnology</td>
                            </tr>
                            <tr>
                                <td>Inorganic Chemistry</td>
                                <td>Saakar 2.0 2026 Physics</td>
                            </tr>
                            <tr>
                                <td>Question Bank</td>
                                <td>Saakaar 2.0 2026 Mathematics</td>
                            </tr>
                            <tr>
                                <td>Test Series</td>
                                <td>Saakaar 2.0 2026 Chemistry</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3>Free IIT JAM Online Coaching by PW</h3>
                    <p>Vigyan Vriksh offers free online coaching for the IIT JAM 2025 exam to help students prepare easily and effectively. The course includes useful video lessons, simple study materials, and full support from expert teachers. It is designed to make learning easy and stress-free. Students can join PW’s YouTube channel for free classes and start their IIT JAM preparation.</p>

                    <h3>IIT JAM Online Coaching in India</h3>
                    <p>Vigyan Vriksh offers IIT JAM online coaching in India, with both paid and free options to help with your exam preparation. Our courses include detailed study materials, interactive classes, and practice sets that follow the latest IIT JAM 2026 exam pattern. Students can also take mock exams and get helpful guidance to prepare well for the IIT JAM 2025 exams. Whether you choose our paid or free courses, you'll have access to great resources to support your IIT JAM preparation.</p>

                    <h3>IIT JAM Online Coaching Features</h3>
                    <p>Vigyan Vriksh offers a comprehensive online coaching program for IIT JAM 2025, perfect for B.Sc. first-year, second-year, final-year students, and dropouts. IIT JAM Online Coaching Features include:</p>
                    <ul className="list-unstyled">
                        <li>Complete Syllabus Coverage: Thorough coverage of the IIT JAM 2026 Syllabus.</li>
                        <li>Practice Questions: Over 2000 practice questions with detailed solutions in Daily Practice Problems (DPPs).</li>
                        <li>Mock Tests: 10+ practice tests to simulate exam conditions.</li>
                        <li>Free Lectures: Additional lectures for Chemistry for IIT JAM Biotechnology preparation.</li>
                        <li>Live Classes: Interactive sessions with qualified faculty.</li>
                        <li>Lecture Planner: Timings and topics provided in advance.</li>
                        <li>Lecture Notes & DPPs: Provided after every lecture, including quiz-format DPPs for an exam-like experience.</li>
                        <li>24×7 Doubt Engine: Available for resolving student queries.</li>
                        <li>Regular Tests & Doubt Sessions: Tests following basic concept completion and regular doubt-clearing sessions.</li>
                        <li>Student-Centric Approach: Focused on enhancing student performance.</li>
                    </ul>
                </div>
            </section>

            <Footer />
        </>
    );
}
export default IITGate;